import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { makeStyles } from '@material-ui/core/styles';
// import FormControl from '@material-ui/core/FormControl';
// import OutlinedInput from '@material-ui/core/OutlinedInput';
import LabelFilterWrap from 'components/molecules/LabelFilterWrap';

import {
  adexMatchingList,
  adexMatchingAdd,
  adexMatchingModify,
  adexMatchingModifies,
} from 'lib/api/adex';

import FilterWrap from 'components/atoms/FilterWrap';
import NewInput from 'components/atoms/NewInput';
import NewButton from 'components/molecules/NewButton';
import TableContainer from 'components/molecules/MbTable';
import NewCommonFilter from 'components/organisms/NewCommonFilter';
import SnackbarWrap from 'components/organisms/Snackbar/SnackbarWrap';
import Modal from 'components/organisms/NewModal';
import Popover from 'components/molecules/Popover';

const useStyles = makeStyles((theme) => ({
  textField: {
    '& input, ': {
      padding: '8px 10px 7px',
      fontSize: 15,
    },
    '&.inTable': {
      width: 250,
    },
    '&.isPopup': {
      width: 250,
      maxWidth: 250,
      padding: 0,
      margin: 0,
      borderColor: '#e8e9ec',
    },
  },
  border: {
    border: '1px solid #e8e9ec',
  },
  modalText: {
    marginTop: 0,
    marginBottom: 10,
    color: theme.palette.primary.mainColor,
  },
}));

let closePopover = null;
const TransMatching = (props) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const { sendTpCode } = props;

  let initMatchingParams = {
    uri: '/product/adex/transMatching',
    sendTpCode: sendTpCode,
    state: null,
  };
  const initSnackbar = {
    state: false,
    variant: 'success',
    message: '',
  };

  const initError = {
    mediaScriptNo: {
      state: false,
      helperText: '',
    },
    mediaId: {
      state: false,
      helperText: '',
    },
  };

  const [params, setParams] = useState(initMatchingParams);
  const [error, setError] = useState(initError);
  const [isLoading] = useState(false);
  const [reGetData, setReGetData] = useState(false);
  const [initialization, setInitialization] = useState(false);
  const [snackbar, setSnackbar] = useState(initSnackbar);
  const initModal = {
    open: false,
    params: {
      sendTpCode: sendTpCode,
      mediaScriptNo: '',
      mediaId: '',
      memo: '',
    },
    disable: '',
  };
  const [modal, setModal] = useState(initModal);

  // const stateList = [
  //   { label: '전체', value: '00' },
  //   { label: '게재중', value: '01' },
  //   { label: '중지', value: '02' },
  // ];

  useEffect(() => {
    if (reGetData === true) {
      setReGetData(false);
    }
  }, [reGetData]);

  useEffect(() => {
    if (initialization === true) {
      setInitialization(false);
    }
  }, [initialization]);

  // header 및 body 컬럼 커스텀
  const customized = {
    NO: {
      merged: true,
    },
    PLTFOM_TYPE: {
      makeHead: (headsMap) => {
        return <>유형구분</>;
      },
      makeBody: (rowObj, headsMap) => {
        return <>{rowObj['PLTFOM_TYPE']}</>;
      },
      headStyle: {
        width: 10,
      },
    },
    MEMO: {
      makeBody: (rowObj, headsMap) => {
        let memo = rowObj.MEMO;
        if (rowObj.MEMO === null) {
          memo = '';
        }
        return (
          <>
            <NewInput
              className={`inTable ${classes.textField}`}
              type={'tableInput'}
              placeholder="메모 입력 후 'ENTER'를 눌러주세요."
              value={memo}
              onKeyPress={(e) => handleMemoKeyPress(e, rowObj)}
            />
          </>
        );
      },
    },
    STATE: {
      makeHead: (headsMap) => {
        return <>게재상태</>;
      },
      makeBody: (rowObj, headsMap) => {
        return (
          <>
            <NewButton
              title={t('광고 on/off')}
              icon="faPowerOff"
              iconBtn
              onClick={() => handleStateToggle(rowObj)}
              style={rowObj.STATE === 'Y' ? { backgroundColor: '#79bd2f' } : {}}
              color={rowObj.STATE === 'Y' ? '#fff' : undefined}
            />
          </>
        );
      },
    },
  };

  /**
   * 라디오박스 옵션변경시
   * @param e
   */
  const handleOptionChange = (e) => {
    const { name, value } = e.target;
    const targetValue = value === '' ? null : value;
    const newParams = {
      ...params,
      [name]: targetValue,
    };
    setParams(newParams);
    closePopover();
  };

  /**
   * 필터창 닫는 핸들링 받아오는 함수
   */
  const getOnClose = (handleClose) => {
    closePopover = handleClose;
  };

  /**
   * 지면등록함수
   */
  const handleSubmit = () => {
    if (
      (modal.params.mediaScriptNo === '' ||
        modal.params.mediaScriptNo === null) &&
      (modal.params.mediaId === '' || modal.params.mediaId === null)
    ) {
      // handleModalClose();
      // setSnackbar({
      //   ...initSnackbar,
      //   state: true,
      //   variant: 'error',
      //   message: '스크립트 번호 또는 매체 아이디는 필수 입니다.',
      // });

      setError({
        ...initError,
        mediaScriptNo: {
          state: true,
          helperText: '스크립트 번호 또는 매체 아이디는 필수 입니다.',
        },
      });
      return false;
    } else {
      setError(initError);
    }

    adexMatchingAdd(modal.params)
      .then((response) => {
        setSnackbar({
          ...initSnackbar,
          state: true,
          variant: 'success',
          message: response.data.message,
        });
        setReGetData(true);
      })
      .catch((error) => {
        setSnackbar({
          ...initSnackbar,
          state: true,
          variant: 'error',
          message: error,
        });
        setReGetData(false);
      });
    handleModalClose();
  };

  /**
   * 테이블 로우를 수정하기 위한 API 통신 함수
   * @param tempParams
   */
  const handleAdexTransMatchingModify = (tempParams) => {
    adexMatchingModify(tempParams)
      .then((response) => {
        setSnackbar({
          ...initSnackbar,
          state: true,
          variant: 'success',
          message: response.data.message,
        });
        setReGetData(true);
      })
      .catch((error) => {
        setSnackbar({
          ...initSnackbar,
          state: true,
          variant: 'error',
          message: error,
        });
      });
  };

  const handleMemoKeyPress = (e, props) => {
    if (e.charCode === 13) {
      let tempParams = {
        sendTpCode: sendTpCode,
        exlNo: props.EXL_NO,
        memo: e.target.value + '',
      };
      handleAdexTransMatchingModify(tempParams);
    }
  };

  /**
   * 게재 상태 토글 버튼 이벤트 함수
   * @param rowData
   */
  const handleStateToggle = (rowData) => {
    const { EXL_NO, STATE } = rowData;
    let tempParams = {
      sendTpCode: sendTpCode,
      exlNo: EXL_NO,
      state: STATE === 'Y' ? '02' : STATE === 'N' && '01',
    };
    handleAdexTransMatchingModify(tempParams);
  };

  /**
   * 테이블 클릭 후 세부정보 받아올때 보낼 param setting 해주는 함수
   * @param {json} data 테이블 로우 데이터
   */
  const makeSubParam = (data) => {
    return {
      statsDttm: data.STATS_DTTM,
    };
  };

  /**
   * 필터 초기화
   */
  const handleOnReset = () => {
    setInitialization(true);
    setParams(initMatchingParams);
  };

  const getParam = (newParams) => {
    setParams({
      ...params,
      ...newParams,
    });
  };

  /**
   * 스낵바 닫는 함수
   * 연속 클릭이 들어왔을 때는 기존 스낵바를 유지
   * @param event
   * @param reason
   */
  const handleSnackBarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    let newSnackbar = {
      ...snackbar,
      state: false,
      message: '',
    };
    setSnackbar(newSnackbar);
  };

  const handleModalOpen = () => {
    setModal({
      ...modal,
      open: true,
      headerTitle: '지면 등록',
    });
  };

  /**
   * 체크박스 Btn Callback 함수
   * @param type String (엑션타입)
   * @param rowData Array ( 체크 유니크값)
   */
  const handleCheckBtnController = (type, data) => {
    let tmpExlNo = [];
    data.forEach(function (rowData) {
      tmpExlNo.push(rowData.EXL_NO);
    });

    let params = {};
    if (type === 'start') {
      params = {
        sendTpCode: sendTpCode,
        state: '01',
        exlNos: tmpExlNo.join(),
      };
    } else if (type === 'stop') {
      params = {
        sendTpCode: sendTpCode,
        state: '02',
        exlNos: tmpExlNo.join(),
      };
    }

    adexMatchingModifies(params)
      .then((response) => {
        setSnackbar({
          ...initSnackbar,
          state: true,
          variant: 'success',
          message: response.data.message,
        });
        setReGetData(true);
      })
      .catch((error) => {
        setSnackbar({
          ...initSnackbar,
          state: true,
          variant: 'error',
          message: error,
        });
        setReGetData(false);
      });
  };

  const handleModalClose = () => {
    setModal(initModal);
  };

  /**
   * 모달 데이터 변경했을 때 실행되는 함수
   * @param newParams
   */
  const modalGetParam = (newParams) => {
    setModal({
      ...modal,
      params: {
        ...modal.params,
        ...newParams,
      },
    });
  };

  return (
    <>
      <FilterWrap handleOnReset={handleOnReset}>
        <NewCommonFilter
          initialization={initialization}
          getParam={getParam}
          params={params}
          useDate={false}
          useExternalFilter={false}
        />
        <Popover
          name="state"
          label={t('상태')}
          getOnClose={getOnClose}
          selectedLabel={t(
            params.state === '01'
              ? '게재중'
              : params.state === '02'
              ? '중지'
              : '전체'
          )}
          filtered={params.state !== ''}
          filterType="radio"
          optionSelectedValue={params.state ? params.state : ''}
          optionList={[
            { label: '전체', value: '' },
            { label: '게재중', value: '01' },
            { label: '중지', value: '02' },
          ]}
          optionOnChange={handleOptionChange}
        />
        <LabelFilterWrap onClick={handleModalOpen} label={t('등록')} />
      </FilterWrap>
      <TableContainer
        dataReqPromise={adexMatchingList}
        params={{ ...params }}
        getParam={getParam}
        dense
        customized={customized}
        hasExcel
        makeSubParam={makeSubParam}
        isLoading={isLoading}
        reGetData={reGetData}
        sort="desc"
        order={'NO'}
        toolTip={t(
          '스크립트 OFF 하면 API 자동 OFF / 재 진행 시엔 API 수동으로 게재해야 함'
        )}
        hasCheckbox={true}
        hasActController={{
          start: true,
          stop: true,
        }}
        headCallBack={handleCheckBtnController}
      />
      <Modal
        open={modal.open}
        headerTitle={modal.headerTitle}
        handleClose={handleModalClose}
        confirmBtnOpen
        confirmOnClick={handleSubmit}
        toolTip={
          '매체 아이디로 등록 시: 매체 사이트 및 지면 모두 게재 중인 모든 지면'
        }
      >
        <p className={classes.modalText}>
          매체 스크립트 번호 혹은 매체 아이디 중 1개로만 등록이 가능합니다.
        </p>
        <table>
          <tbody>
            <tr>
              <th>* {t('매체 스크립트 번호')}</th>
              <td>
                <NewInput
                  name="mediaScriptNo"
                  callBack={modalGetParam}
                  error={error.mediaScriptNo.state}
                  helperText={error.mediaScriptNo.helperText}
                  value={modal.params.mediaScriptNo}
                />
              </td>
            </tr>
            <tr>
              <th>* {t('매체 아이디')}</th>
              <td>
                <NewInput
                  name="mediaId"
                  callBack={modalGetParam}
                  error={error.mediaId.state}
                  helperText={error.mediaId.helperText}
                  value={modal.params.mediaId}
                />
              </td>
            </tr>
            <tr>
              <th>{t('메모')}</th>
              <td>
                <NewInput
                  name="memo"
                  callBack={modalGetParam}
                  value={modal.params.memo}
                />
              </td>
            </tr>
          </tbody>
        </table>
      </Modal>

      <SnackbarWrap
        open={snackbar.state}
        onClose={handleSnackBarClose}
        variant={snackbar.variant}
        message={snackbar.message}
      />
    </>
  );
};

export default TransMatching;
